import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-11.png';
import Img1 from '../../../assets/images/itm-5.png';
import Img2 from '../../../assets/images/itm-10.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-8.png';
import corporateITM from '../../../assets/images/itm-academy-img.jpeg'

const introSectionData3: IntroSectionData = {
  sectionTitle: "IT Monkeys Academy",
  sectionSubtitle: "Centre de formation spécialisé",
  tabsData: [
    {
      id: 0,
      title: "IT Monkeys Academy",
      heading: "Maîtrise de la technologie",
      text: '',
    },
 
  ],
  fixedImageSrc: corporateITM,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
};

export default introSectionData3;